/** Read-only document view for evidence returned as plain text. */

/** Props for a plain-text evidence document. */
export interface PlainTextEvidencePanelProps {
  text: string;
}

/** Render long-form text as a clean, readable letter without extra chrome. */
export function PlainTextEvidencePanel({ text }: PlainTextEvidencePanelProps) {
  return (
    <div className="h-full min-h-0 overflow-y-auto bg-white">
      <article className="mx-auto max-w-3xl whitespace-pre-wrap break-words px-8 py-10 text-sm leading-7 text-primaryGray-2 md:px-12 md:py-14">
        {text}
      </article>
    </div>
  );
}
